<template>
	<v-card 
		class="mx-auto"
		max-width="600"
		width="100%"
		flat
	>
		<v-app-bar flat color="transparent">
			<v-btn v-if="step > 0" icon @click="$emit('previous')">
            	<v-icon>mdi-arrow-left</v-icon>
            </v-btn>

			<v-toolbar-title class="text-h6">
				{{ title }}
			</v-toolbar-title>

			<v-spacer></v-spacer>

			<!-- <v-btn icon >
				<v-icon>mdi-dots-vertical</v-icon>
			</v-btn> -->
		</v-app-bar>
		<!-- <v-card-title>{{ title }}</v-card-title> -->
		<!-- <v-card-subtitle>{{ subtitle }}</v-card-subtitle > -->
		<!-- <v-card-subtitle v-if="subtitle && subtitle.length">{{ subtitle }}</v-card-subtitle > -->
		<v-card-text>
			{{ text }}
		</v-card-text>
		<v-card-text>
			<v-list flat subheader three-line >
				<v-subheader>General</v-subheader>

				<v-list-item-group
					v-model="settings"
					multiple
					active-class=""
				>
					<v-list-item>
						<template v-slot:default="{ active }">
							<v-list-item-action>
							<v-checkbox :input-value="active"></v-checkbox>
							</v-list-item-action>

							<v-list-item-content>
							<v-list-item-title>Notifications</v-list-item-title>
							<v-list-item-subtitle>Notify me about updates to apps or games that I downloaded</v-list-item-subtitle>
							</v-list-item-content>
						</template>
					</v-list-item>

					<v-list-item>
					<template v-slot:default="{ active }">
						<v-list-item-action>
						<v-checkbox :input-value="active"></v-checkbox>
						</v-list-item-action>

						<v-list-item-content>
						<v-list-item-title>Sound</v-list-item-title>
						<v-list-item-subtitle>Auto-update apps at any time. Data charges may apply</v-list-item-subtitle>
						</v-list-item-content>
					</template>
					</v-list-item>

					<v-list-item>
					<template v-slot:default="{ active }">
						<v-list-item-action>
						<v-checkbox :input-value="active"></v-checkbox>
						</v-list-item-action>

						<v-list-item-content>
						<v-list-item-title>Auto-add widgets</v-list-item-title>
						<v-list-item-subtitle>Automatically add home screen widgets when downloads complete</v-list-item-subtitle>
						</v-list-item-content>
					</template>
					</v-list-item>
				</v-list-item-group>
			</v-list>
			<!-- <v-form ref="form">
				<v-row>
					<v-col cols="12">
						<v-text-field
							label="Реєстраційний номер"
							v-model.trim="item.number"
							outlined
							rounded
							clearable
							hide-details="auto"
							:rules="[rules.required]"
							@keyup.ctrl.90="keyupNumber"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field
							label="VIN-код"
							v-model.trim="item.vin"
							outlined
							rounded
							clearable
							hide-details="auto"
							:rules="[rules.required]"
							@keyup.ctrl.90="keyupVin"
						></v-text-field>
					</v-col>
				</v-row>
			</v-form> -->
		</v-card-text>

		<v-card-actions>
			<v-spacer></v-spacer>
				<v-btn
					color="indigo"
					dark
					rounded
					block
					@click="onNext"
				>
					Далі
				</v-btn>
			<v-spacer></v-spacer>
		</v-card-actions>
	</v-card>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin],

	props: {
		code:				{ type: String },
		title:				{ type: String, default: "Експлуатація" },
		subtitle:			{ type: String, default: "" },
		text:				{ type: String, default: "Декілька питань щодо експлуатації транспортного засобу" },
		defaultNumber:		{ type: String, default: 'KA1223AP'},
		defaultVin:			{ type: String, default: 'WAUZZZ4M0HD001505'}, //WAUC8AFC0HN089495
	},

	methods: {

		onNext(){
			if (this.$refs.form.validate()) {
				this.$emit('next')
			}
		},

		keyupNumber(){
			//this.item.number = this.defaultNumber
			this.$set(this.item,'number', this.defaultNumber)
		},

		keyupVin(){
			//this.item.vin = this.defaultVin
			this.$set(this.item,'vin', this.defaultVin)
		},
	},
}
</script>
